module.exports = __webpack_public_path__ + "img/img9.42185a28.png";